export default "<app-detail [title] = \"title\" [cardType] = \"cardType\" [buttonType] = \"buttonType\" [cards] = \"apiEnablers\" ></app-detail>\n"